import React, { Fragment } from 'react';

import { Spin, Typography } from 'antd';

import { useLoadFiles } from 'v2/hooks/useLoadFiles';

import { Icon } from '@eduzz/ui-antd-theme';

import { useFiscalDocuments } from '../../context';

const getFileIcon = (ext: string) => {
  if (['jpeg', 'jpg', 'png', 'gif'].includes(ext)) {
    return <Icon.Image size={18} />;
  }

  if (ext === 'pdf') {
    return <Icon.FileText size={18} />;
  }

  return <Icon.File size={18} />;
};

const STATUSES = [undefined, 'Aguardando Aprovação', 'Aprovado', 'Reprovado'];

const Files = () => {
  const { selectedData } = useFiscalDocuments();
  const { files, isLoading } = useLoadFiles(selectedData.id);

  if (isLoading) {
    return (
      <div className='py-2 text-center'>
        <Spin />
      </div>
    );
  }

  if (!files.length) {
    return (
      <Typography.Text type='secondary' className='block pt-5 text-center'>
        Nenhum registro encontrado.
      </Typography.Text>
    );
  }

  return (
    <Fragment>
      {files.map(item => (
        <Typography.Link
          key={item.id}
          href={item.url}
          target='_blank'
          rel='noopener noreferrer'
          className='block w-full capitalize'
        >
          <div className='flex items-center gap-3 py-1'>
            <span>{getFileIcon(item.ext)}</span>
            <div className='min-w-0 flex-1'>
              <Typography.Text className='block'>{item.name}</Typography.Text>
              <Typography.Text type='secondary' className='block text-xs italic'>
                {STATUSES[Number(item.status)] || 'Pendente'}
              </Typography.Text>
            </div>
          </div>
        </Typography.Link>
      ))}
    </Fragment>
  );
};

export default Files;
